import React from 'react';
import { CheckIcon } from 'lucide-react';
const items = [{
  label: 'Caliente',
  detail: 'tibia o recién hecha'
}, {
  label: 'Cocido',
  detail: 'fácil de asimilar'
}, {
  label: 'Simple',
  detail: 'pocas combinaciones'
}, {
  label: 'Proteico',
  detail: 'para dar saciedad'
}, {
  label: '15 minutos',
  detail: 'sin horas de cocina'
}];
export function DinnerChecklist() {
  return <figure className="my-7" data-id="element-160" data-mp="8fxc64lqzd1l">
      <div className="rounded-sm border border-brand-blush bg-brand-light px-5 py-5 sm:px-6" data-id="element-161" data-mp="8h8owtx67v4u">
        <p className="font-display text-lg font-bold text-ink" data-id="element-162" data-mp="3ofmicp6cyvx">La cena nocturna ideal es…</p>
        <ul className="mt-4 grid gap-3 sm:grid-cols-5" data-id="element-163" data-mp="3uv0a1mg0too7">
          {items.map(item => <li key={item.label} className="flex items-start gap-2.5 sm:flex-col sm:items-center sm:text-center" data-id="element-164" data-mp="3px70cjfiecj6">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand text-white" data-id="element-165" data-mp="3lu23awe7731x">
                <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-166" data-mp="3gwipfxlewsai" />
              </span>
              <span className="font-sans leading-tight" data-id="element-167" data-mp="wxvhn31ou5jh">
                <span className="block whitespace-nowrap text-[0.9rem] font-bold text-ink" data-id="element-168" data-mp="11qolzpt8vbv1">{item.label}</span>
                <span className="mt-0.5 block text-[0.75rem] text-ink-soft" data-id="element-169" data-mp="nzjha9b0rtdu">{item.detail}</span>
              </span>
            </li>)}
        </ul>
      </div>
      <figcaption className="mt-2 font-sans text-xs leading-relaxed text-ink-muted" data-id="element-170" data-mp="1fpwkshlhwhyp">
        Cinco principios que comparten las cenas que mejor toleran muchas mujeres. Gráfico ilustrativo.
      </figcaption>
    </figure>;
}